<template>
  <div 
    id="app" 
    class="l-body" 
    :class="platformName"
    :style="{
      overflow: isMenuOpen ? 'hidden' : ''
    }">
    <common-loader
      :class="{
        'is-loading': isLoaderLoading
      }" />

      <!-- <common-loader style="opacity: 1;visibility: visible;" /> -->

    <global-header />
    
    <!-- SP メニュー -->
    <global-navigation />
    
    <!-- PC 左メニュー -->
    <destination-menu />

    <!-- トップから destination へ遷移する際の拡大用画像 -->
    <cover-image />

    <div class="l-content" 
      :class="{
        'is-menu-open': isMenuOpen
      }">
      <!-- メニューを閉じるためのヒットエリア -->
      <div v-show="isMenuOpen" class="l-content__hitArea" @click.prevent="onClickContent"></div>

      <main class="l-main"
        :class="{
          'is-loading': isLoading
        }">
        <router-view :key="$route.path"></router-view>
      </main>
      
      <global-footer
        v-show="isInitialized"
        :class="{
          'is-loading': isLoading
        }"
      />
    </div>

    <cominca-pagetop :is-visible="isPageTopVisible" />
  </div>
</template>

<style>
  
</style>

<script>
  import platform from 'platform'
  /**
   * Modules
   */
  import { mapGetters, mapActions, mapMutations } from 'vuex'

  /**
   * Share Partial
   */
  import globalHeader from '~/partial/global-header'
  import globalNavigation from '~/partial/global-navigation'
  import globalFooter from '~/partial/global-footer'
  import DestinationMenu from '~/partial/destination-menu'
  import CoverImage from '~/partial/cover-image'
  import ComincaPagetop from '~/partial/cominca-pagetop'
  import CommonLoader from '~/partial/common-loader'

  import store from '~/store'

  export default {
    name: 'app',
    components: {
      globalHeader,
      globalNavigation,
      globalFooter,
      DestinationMenu,
      CoverImage,
      ComincaPagetop,
      CommonLoader,
    },
    data: () => {
      return {
        isInitialized: false,
        isPageTopVisible: false
      }
    },
    watch: {
      '$window.scrollY'() {
        if(this.$window.scrollY > this.$window.height) {
          if(!this.isPageTopVisible) {
            this.isPageTopVisible = true
          }
        } else {
          if(this.isPageTopVisible) {
            this.isPageTopVisible = false
          }
        }
      }
    },
    metaInfo() {
      const head = {};
      head.title = this.getInfo().meta.title;
      head.titleTemplate = null;
      head.meta = this.getMeta();
      return head;
    },
    computed: {
      platformName() {
        return platform.name
      },
      isLoading() {
        return this.routeState().isLoading || this.postsState().isLoading || this.isLoaderLoading
      },
      ...mapGetters({
        'getInfo': 'route/getInfo',
        'getMeta': 'route/getMeta',
        'routeState': 'route/getState',
        'postsState': 'posts/getState',
        'isMenuOpen': 'menu/isOpen',
        'isLoaderLoading': 'loader/isLoading',
      }),
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.isInitialized = true
      })
    },
    methods: {
      onClickContent() {
        if(this.isMenuOpen) {
          this.hideMenu()
        }
      },
      ...mapMutations({
        'hideMenu': 'menu/HIDE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue